export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_48_MANAGER': 'Manager',
    '_59_ROLE': 'Role',
    '_67_SUPERGROUP': 'SuperGroup',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7374_DAYS_IN_SUPERGROUP': 'Days in Supergroup',
    '_11275_DAYS_REPORTING_TO_MANAGER': 'Days Reporting to Manager',
    '_842_N_A': 'N/A'
};
